import { faCheck, faUndo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from '../_helpers/withRouter';
import Select from 'react-select';
import {
    Breadcrumb, BreadcrumbItem, Button, ButtonDropdown, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, Row
} from 'reactstrap';
import Swal from 'sweetalert2';
import { authActions, convenioAction, usuarioAction } from '../_actions';
import NavBar from '../_components/navbar';
import { stringUtils } from '../_utils/';

const ConvenioEdit = (props) => {

    const dispatch = useDispatch();
    const [, forceUpdate] = React.useState(0);
    const [id, setId] = useState(0);
    const [isOpenDrop, setOpenDrop] = useState(false);

    const toggleDropDown = () => setOpenDrop(!isOpenDrop);

    useEffect(() => {
        const { match: { params } } = props;
        dispatch(usuarioAction.getSelectInseminadores());

        if (params.id) {
            dispatch(convenioAction.getConvenioById(params.id, true));
            setId(params.id);
        } else {
            if (authActions.isGestor() == false) {
                props.history.push('/convenios/');
            }
        }
    }, []);

    const handleChange = prop => event => {
        const { dispatch } = props;
        dispatch(convenioAction.onChangeProps(prop, event));

    };

    const handleSelectChange = prop => event => {

        var event2 = {
            type: 'select',
            target: {
                value: event.value
            }
        };
        dispatch(convenioAction.onChangeProps(prop, event2));

    };

    const handleValidation = event => {

        ('salvando...')

        var valid = true;
        var errors = '';

        if (props.convenio.nome === null || props.convenio.nome === '') {
            valid = false;
            errors += '<li style="float:left;">Informe um nome válido!</li><br>';
        }

        if (props.convenio.endereco === null || props.convenio.endereco === '') {
            valid = false;
            errors += '<li style="float:left;">Informe um endereço válido!</li><br>';
        }

        if (props.convenio.cnpj === null || props.convenio.cnpj === '') {
            valid = false;
            errors += '<li style="float:left;">Informe um CNPJ válido!</li><br>';
        }

        if (props.convenio.id_usuario === 0 || props.convenio.id_usuario === '') {
            valid = false;
            errors += '<li style="float:left;">Informe um inseminador!</li><br>';
        }

        if (!valid) {

            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });

        }
        return valid;
    };

    const renderOptionsInseminador = () => {
        return props.usuario.usuario.map((p, i) => {
            return (
                { value: p.Value, label: p.Text }
            );
        });
    };

    const handleSubmit = event => {

        event.preventDefault();
        const { match: { params } } = props;

        if (handleValidation()) {

            let payload = {
                id: params.id,
                nome: props.convenio.nome,
                endereco: props.convenio.endereco,
                cnpj: props.convenio.cnpj.split('.').join('').replace(/[-/.]/g, ''),
                id_usuario: props.convenio.id_usuario
            };

            if (params.id) {
                dispatch(convenioAction.editConvenioInfo(params.id, payload));

            } else {
                dispatch(convenioAction.createConvenio(payload));
            }
        }

    };

    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <Breadcrumb>
                                    <BreadcrumbItem><a href="/convenios">Lista de Convênios</a></BreadcrumbItem>
                                    <BreadcrumbItem active>Convênio {props.convenio.id}</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={(event) => handleSubmit(event)}>
                            <Row>
                                <Col md={4} lg={5}>
                                    <FormGroup>
                                        <Label className="left" for="nome">Nome *</Label>
                                        <Input
                                            id="nome"
                                            label="Nome"
                                            className="form-control"
                                            value={props.convenio.nome}
                                            onChange={handleChange('nome')} />
                                    </FormGroup>
                                </Col>
                                <Col md={4} lg={3}>
                                    <FormGroup>
                                        <Label className="left" for="endereco">Endereço *</Label>
                                        <Input
                                            id="endereco"
                                            label="Endereço"
                                            className="form-control"
                                            value={props.convenio.endereco}
                                            onChange={handleChange('endereco')} />
                                    </FormGroup>
                                </Col>
                                <Col md={4} lg={3}>
                                    <FormGroup>
                                        <Label className="left" for="cnpj">CNPJ *</Label>
                                        <Input
                                            id="cnpj"
                                            label="CNPJ"
                                            className="form-control"
                                            value={stringUtils.cnpjMask(props.convenio.cnpj)}
                                            onChange={handleChange('cnpj')}
                                            margin="normal"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={10} lg={5}>
                                    <FormGroup>
                                        <Label className="left" for="id_usuario">Inseminador *</Label>
                                        <Select
                                            style={{ minWidth: '500px' }}
                                            className="form-control basic-single p-0 border-0"
                                            classNamePrefix="select"
                                            value={renderOptionsInseminador().filter(function (option) {
                                                return option.value == (props.convenio.id_usuario || '0');
                                            })}
                                            onChange={handleSelectChange('id_usuario')}
                                            isSearchable
                                            placeholder="Selecione..."
                                            id="id_usuario"
                                            name="id_usuario"
                                            options={renderOptionsInseminador()}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <hr />
                            <br />
                            <Row>
                                <Col className="left" md="3" lg="3">
                                    <span>* Campos obrigatórios</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="d-flex  justify-content-end" lg="12">
                                    <Button className="mr-1" variant="contained" color="secondary" component='a' href="/convenios">Voltar <FontAwesomeIcon icon={faUndo} /></Button>
                                    <Button variant="contained" color="primary" type="submit" style={{ backgroundColor: 'var(--primary-color)', border: 'none' }}>Salvar <FontAwesomeIcon icon={faCheck} /></Button>
                                    {id > 0 &&
                                        <ButtonDropdown className="mr-1" isOpen={isOpenDrop} toggle={toggleDropDown}>
                                        </ButtonDropdown>
                                    }
                                </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
            </Container>

            
        </div>
    );
}


const mapStateToProps = (state) => {
    return state;
}

const connectedConvenioEditPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(ConvenioEdit));

export { connectedConvenioEditPage as ConvenioEdit };
